import React, { useEffect } from 'react';
import './Benchmarks.css';

function Benchmarks() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="benchmarks">
      <div className="benchmarks-content">
        <h1>In depth benchmarks coming soon...</h1>
      </div>
    </div>
  );
}

export default Benchmarks;
